<template>
    <div class="flex flex-col items-center justify-items-center lg:px-64 md:px-32 sm:px-16 px-3 mb-40">
        <h2 class="mt-16 mb-10 tracking-wider font-semibold text-center text-3xl">{{ $route.params.title }}</h2>
        <tailwind-image
            v-if="linkExists(0)"
            :link="links[0]"
            aspect-ratio="7/12"
            class="w-full"
        ></tailwind-image>
        <div class="mt-5">
            Der Sakralbau wurde für eine Gemeinde in Rheinland-Pfalz entworfen. Der ikonographische Baukörper ist aus zweifach gekrümmten Betonflächen gestaltet, die mit einer Keramikbeschichtung versehen sind. Von außen wirkt das Gebäude als abstraktes, monolithisches Volumen. Die Gebäudeform entwickelt sich kontinuierlich von einer dreischiffigen Geometrie im Eingangsbereich zu einem kugelförmigen Volumen, welches den Hauptraum der Aussegnungshalle bildet. Der zentrale Innenraum ist umlaufend mit hellem Holz ausgekleidet und erzeugt durch die abgerundeten Übergänge von Boden, Wand und Decke einen scheinbar kontinuierlichen Raum. Ziel ist die Vermittlung eines Raumes, der den Besucher von der Außenwelt entrückt und gleichsam eine kontemplative Atmosphäre schafft.
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(1)"
                :link="links[1]"
                aspect-ratio="10/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(2)"
                :link="links[2]"
                aspect-ratio="10/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(3)"
                :link="links[3]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(4)"
                :link="links[4]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(5)"
                :link="links[5]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(6)"
                :link="links[6]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <div class="grid grid-cols-2 w-full mt-5">
            <tailwind-image
                v-if="linkExists(7)"
                :link="links[7]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
            <tailwind-image
                v-if="linkExists(8)"
                :link="links[8]"
                aspect-ratio="7/12"
                class="w-full px-4"
            ></tailwind-image>
        </div>
        <tailwind-image
            v-for="iLink in allRemainingLinks"
            :key="'VueKey' + iLink"
            :link="iLink"
            aspect-ratio="7/12"
            class="w-full my-5"
        ></tailwind-image>
        <span class="mt-5 w-full text-left">
            <p class="font-semibold">Entwurf</p>
            <p>Markus Holzbach Architektur</p>
        </span>
    </div>
</template>
<script>
import TailwindImage from '@/components/TailwindImage';


export default {
    components: {
        TailwindImage,
    },
    props: {},
    data ()
    {
        return {
            links: [
                require( '@/assets/img/pc/Sakralbau_2_a.jpg' ),
                require( '@/assets/img/pc/Sakralbau_6_b.jpg' ),
                // require( '@/assets/img/pc/Sakralbau-2.jpg' ),
                require( '@/assets/img/pc/Sakralbau_5_b.jpg' ),
                require( '@/assets/img/pc/Sakralbau_1_a.jpg' ),
                require( '@/assets/img/pc/Sakralbau_8_b.jpg' ),
                require( '@/assets/img/pc/Sakralbau Fräsmodell.jpg' ),
                require( '@/assets/img/pc/Sakralbau_3_a.jpg' ),
            ],
        };
    },
    methods: {
        linkExists ( index )
        {
            return index in this.links;
        }
    },
    created () { },
    computed: {
        allRemainingLinks ()
        {
            if ( !this.linkExists( 9 ) )
            {
                return [];
            } else
            {
                return this.links.slice( 9 );
            }
        }
    }
};
</script>